import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Button,
  useDisclosure,
  Image,
  Text,
  Icon,
  Flex,
  Box,
  HStack,
  Avatar,
  Textarea,
} from "@chakra-ui/react";
import { RiCustomerServiceFill } from "@remixicon/react";
import navIcon12 from "@/assets/images/swsy_h.png";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectAvatar } from "@/reducer/userslice";

type conversation = {
  speaker: "ai" | "human";
  message: string;
  username: string;
  createAt: string;
};

const CustomerService = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const [text, setText] = useState("");
  const avatar = useSelector(selectAvatar);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value;
    setText(inputValue);
  };

  const handleSubmit = () => {};

  const sessionList: conversation[] = [
    {
      speaker: "ai",
      message:
        "欢迎使用ALDGPT小助手～人工客服工作时间为工作日09:00-12:00，13:00-18:00，非工作日欢迎您留言，我们将在24小时内答复您。",
      username: "ALDGPT小助手",
      createAt: "16:26:29",
    },
    // {
    //   speaker: "human",
    //   message: "你好，你能为我做什么",
    //   username: "ALDGPT小助手",
    //   createAt: "16:26:29",
    // },
  ];

  return (
    <Popover placement="left" isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Button variant="unstyled" onClick={onToggle}>
          <Icon
            as={RiCustomerServiceFill}
            boxSize={"32px"}
            color={isOpen ? "#496AE1" : "#B9B9B9"}
          />
          <Text fontSize={"12px"} color={isOpen ? "#496AE1" : "#B9B9B9"}>
            客服
          </Text>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        {/* <PopoverArrow /> */}
        <PopoverCloseButton />
        <PopoverHeader>
          <Flex alignItems={"center"}>
            <Avatar
              border={"1px solid rgba(238, 241, 247, 0.5)"}
              boxSize={"32px"}
              src={navIcon12}
            />
            <Box ml="10px">
              <Box fontSize="14px">ALDGPT小助手</Box>
              <HStack fontWeight={"bold"} fontSize="12px">
                <Text color={"#27314D"}>拨打咨询专线</Text>{" "}
                <Text color={"#496AE1"}>400-064-1001</Text>
              </HStack>
            </Box>
          </Flex>
        </PopoverHeader>
        <PopoverBody p="0">
          <Box h="240px" overflowY={"auto"} bgColor="rgba(238, 241, 247, 0.5)" p="16px">
            {sessionList.map((item, index) => {
              return (
                <Box key={index}>
                  {item.speaker === "ai" && (
                    <Flex mb="15px">
                      <Avatar
                        mr="10px"
                        w="32px"
                        h="32px"
                        name="ALDGPT"
                        // borderRadius={"2px"}
                        src={navIcon12}
                      />
                      <Box fontSize={"12px"}>
                        <HStack color="#27314D" mb="10px">
                          <Text>{item.username}</Text>
                          <Text>{item.createAt}</Text>
                        </HStack>
                        <Box color={"#3D3D3D"} bgColor="#FFFFFF" p="12px 10px">
                          {item.message}
                        </Box>
                      </Box>
                    </Flex>
                  )}
                  {item.speaker === "human" && (
                    <Flex
                      justifyContent={"flex-end"}
                      alignItems="flex-start"
                      mb="15px"
                    >
                      <Box fontSize={"12px"}>
                        <HStack color="#27314D" mb="10px">
                          <Text>{item.createAt}</Text>
                          <Text>{item.username}</Text>
                        </HStack>
                        <Box color={"#3D3D3D"} bgColor="#FFFFFF" p="12px 10px">
                          {item.message}
                        </Box>
                      </Box>
                      <Avatar
                        ml="10px"
                        w="32px"
                        h="32px"
                        name="ALDGPT"
                        // borderRadius={"2px"}
                        src={avatar}
                      />
                    </Flex>
                  )}
                </Box>
              );
            })}
          </Box>
          <Textarea
            fontSize={"12px"}
            color="#8E94A9"
            value={text}
            border="none"
            onChange={handleInputChange}
            placeholder="很高兴为您服务，请描述您的问题"
            size="sm"
            rows={2}
            resize={"none"}
            focusBorderColor="transparent"
            _focus={{
              borderColor: "transparent",
            }}
          />
          <Flex justifyContent={"right"} p="20px 16px">
            <Button
              borderRadius={"0px"}
              width={"56px"}
              height={"29px"}
              color="#FFFFFF"
              bgColor="#496AE1"
              fontWeight={"normal"}
              fontSize="12px"
              _hover={{
                bgColor: "#3F5BC1",
                color: "#E6E6E6",
              }}
              onClick={handleSubmit}
            >
              发送
            </Button>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default CustomerService;
